export default "__VITE_ASSET__eFbM_Xoo__"